import React from "react";

const SvgLegendGeneric = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 19" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path
        id="LegendGeneric_svg__a"
        d="M1215 350l-2.81 6.63-7.19.61 5.46 4.73-1.64 7.03 6.18-3.73 6.18 3.73-1.64-7.03 5.46-4.73-7.19-.61L1215 350z"
      />
    </defs>
    <use
      fill="currentColor"
      xlinkHref="#LegendGeneric_svg__a"
      transform="translate(-1205 -350)"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => (
  <SvgLegendGeneric svgRef={ref} {...props} />
));
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/LegendGeneric.js